import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { UserAgreementConsentHistoryContainerModel } from '../../../../../../models';
import { Observable } from 'rxjs';
import { CmsWebsiteUserAgreementConsentHistoryModifiedContainer } from '../../../data-transfer-objects';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })

export class WebsiteUserAgreementConsentHistoryService extends BaseApiPublicLoginTemplateService<UserAgreementConsentHistoryContainerModel, UserAgreementConsentHistoryContainerModel, UserAgreementConsentHistoryContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-user-agreement-consent-history/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-user-agreement-consent-history/backoffice-ep';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-user-agreement-consent-history/login-ep';
    this.httpClient = http;
  }

  public getUserConsentsByDocGuid(guid: string, visa: ApiVisa
  ): Observable<ApiResponseModel<CmsWebsiteUserAgreementConsentHistoryModifiedContainer>> {
    const endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-user-agreement-consent-history/user-consents/backoffice-ep';
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-user-agreement-consent-history/user-consents/backoffice-ep';
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<CmsWebsiteUserAgreementConsentHistoryModifiedContainer>>(
      apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }
}